import React, { useEffect, useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FaMinusCircle } from "react-icons/fa";

const VisitFollowupForm = ({ followupItem, deleteItem }) => {
  const [newValue, setNewValue] = useState(followupItem.value);
  useEffect(() => {
    followupItem.value = newValue;
  }, [newValue]);
  return (
    <div>
      <Row className="my-2 align-items-center g-2">
        <Col xs={12} sm="auto" className="text-center">
          {followupItem.followupLabel}
        </Col>
        <Col xs={12} sm>
          <InputGroup>
            <Form.Control
              type="number"
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              className="text-center"
            />
            <Button
              variant="outline-danger"
              onClick={() => deleteItem(followupItem.followupId)}
            >
              <FaMinusCircle />
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default VisitFollowupForm;
